import { Injectable } from '@angular/core';
import { CommonConstants } from '../constants/common-constants';
import { decryptData, encryptData } from '../encryptData/encrypt-data.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionListService {

  constructor() { }

  // Save permission after login
  setPermissionList(user: any) {
     localStorage.setItem(CommonConstants.CURRENT_USER, <string>encryptData(user));
  }

  // Get permission
  getPermissionList() {
    var localStorageDetails = localStorage.getItem(CommonConstants.CURRENT_USER);
        if (localStorageDetails != null && localStorageDetails != '') {
          return decryptData(localStorageDetails)
        } else {
          return false
        }
  }

  // Optional: logout function
  logout() {
    localStorage.removeItem(CommonConstants.CURRENT_USER);
  }
}
